import iClinicApi from 'services/iclinic/iClinicApi';
import { RedeemAwardData } from '../types';

export const getReferralsParticipant = () =>
  iClinicApi.get('/referrals/participant/');

export const getReferralAwards = () => iClinicApi.get('/referrals/award/');

export const postReferralsRedeemAward = ({ awardId, data }: RedeemAwardData) =>
  iClinicApi.post(`/referrals/award/${awardId}/redeem/`, data);
